// Utility function to add destination markers with geocoding
export const addDestinationMarkers = async (
  map: google.maps.Map, 
  destinations: Array<{ id: string; name: string; status: string; date_created: string }>,
  markersRef: React.MutableRefObject<google.maps.Marker[]>
) => {
  if (!window.google?.maps) return;

  // Clear existing markers
  markersRef.current.forEach(marker => marker.setMap(null));
  markersRef.current = [];
  
  const geocoder = new google.maps.Geocoder();

  for (const destination of destinations) {
    try {
      const result = await new Promise<google.maps.GeocoderResult[]>((resolve, reject) => {
        geocoder.geocode({ address: destination.name }, (results, status) => {
          if (status === 'OK' && results) {
            resolve(results);
          } else {
            reject(new Error(`Geocoding failed for ${destination.name}: ${status}`));
          }
        });
      });

      if (result && result[0]) {
        const location = result[0].geometry.location;
        
        // Create marker (standard) to avoid AdvancedMarker requirement for Map ID
        const marker = new google.maps.Marker({
          position: location,
          map: map,
          title: destination.name,
          icon: {
            path: google.maps.SymbolPath.CIRCLE,
            scale: 6,
            fillColor: destination.status === 'open' ? '#3B82F6' : '#9CA3AF',
            fillOpacity: 1,
            strokeColor: '#FFFFFF',
            strokeWeight: 2,
          },
        });

        // Create info window
        const infoWindow = new google.maps.InfoWindow({
          content: `
            <div class="p-2">
              <h3 class="font-semibold">${destination.name}</h3>
              <p class="text-sm ${destination.status === 'open' ? 'text-green-600' : 'text-red-600'}">
                Status: ${destination.status}
              </p>
            </div>
          `
        });

        marker.addListener('click', () => {
          infoWindow.open(map, marker);
        });

        markersRef.current.push(marker);
      }
    } catch (error) {
      console.warn(`Could not geocode destination: ${destination.name}`, error);
    }
  }
};